<template>
  <NavbarApp />

  <div class="careers-page-main">
    <section class="careers-hero-section">
      <div class="hero-content">
        <h1 class="hero-title">{{ $t('careers.hero.title') || 'Your Future Starts Here' }}</h1>
        <p class="hero-subtitle">{{ $t('careers.hero.subtitle') || 'Join a dynamic team that values innovation, collaboration, and growth.' }}</p>
      </div>
    </section>

    <div class="main-content-cards-container">
      <div class="content-card-2 openings-card">
        <h2 class="card-title">{{ $t('careers.rightContent.openings.title') || 'Current Job Openings' }}</h2>
        <p class="card-description">
          <i18n-t keypath="careers.rightContent.openings.paragraph1">
            <template #strong><strong>{{ $t('companyName') }}</strong></template>
          </i18n-t>
        </p>
        <p class="card-description">
          <i18n-t keypath="careers.rightContent.openings.paragraph2">
            <template #email><a href="mailto:office@islaw.ro" class="email-link">office@islaw.ro</a></template>
          </i18n-t>
        </p>
        <a href="mailto:office@islaw.ro" class="card-button">{{ $t('careers.openings.applyButton') || 'Apply Now' }}</a>
      </div>

      <div class="content-card-2 internships-card">
        <h2 class="card-title">{{ $t('careers.rightContent.internships.title') || 'Internship Programs' }}</h2>
        <p class="card-description">
          <i18n-t keypath="careers.rightContent.internships.paragraph1">
            <template #strong><strong>{{ $t('companyName') }}</strong></template>
          </i18n-t>
        </p>
        <p class="card-description">
          <i18n-t keypath="careers.rightContent.internships.paragraph2">
            <template #email><a href="mailto:office@islaw.ro" class="email-link">office@islaw.ro</a></template>
          </i18n-t>
        </p>
        <a href="mailto:office@islaw.ro" class="card-button">{{ $t('careers.internships.learnMoreButton') || 'Learn More' }}</a>
      </div>
    </div>
  </div>

  <Section4 />
</template>

<script>
import NavbarApp from '../components/HomePage/navbar-law.vue';
import Section4 from '../components/HomePage/section-4.vue';

export default {
  name: 'CareersPage',
  components: {
    NavbarApp,
    Section4
  }
}
</script>
<style scoped>
/* Overall Page Container */
.careers-page-main {
  background-color: #f0f2f5; /* A very light, cool gray background */
  padding-bottom: 80px;
}

/* --- Hero Section Styling --- */
.careers-hero-section {
  background: #b3c0cd;
  background-size: cover;
  color: #fff;
  align-items: center;
  padding: 80px 0px; /* Generous padding for a grand feel */
  text-align: center;

  height: 200px; /* Minimum height for visual impact */
  margin-bottom: 60px; /* Space before the content cards */
}

.hero-content {
  max-width: 1000px;
  margin: 0 auto;       /* centers the block itself */
  text-align: center;   /* centers the text inside */
}

.hero-title {

  font-size: 3rem;
  font-weight: 600;
  margin-bottom: 20px;
  line-height: 1.1;
  text-shadow: 2px 2px 8px rgba(0, 0, 0, 0.3); /* Subtle text shadow for depth */
  
}

.hero-subtitle {
 
  font-size: 1.6rem;
  font-weight: 300;
  line-height: 1.5;
  opacity: 0.9;
  text-shadow: 1px 1px 4px rgba(0, 0, 0, 0.2);
}

/* --- Main Content Cards Container --- */
.main-content-cards-container {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(380px, 1fr)); /* Two columns on large screens */
  gap: 40px; /* Space between cards */
  max-width: 1200px; /* Max width for the cards section */
  margin: -80px auto 60px; /* Pull cards up into the hero section */
  padding: 0 20px; /* Horizontal padding for smaller screens */
}

/* --- Individual Content Cards --- */
.content-card-2 {
  background-color: #ffffff;
  border-radius: 10px;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1); /* Stronger shadow for floating effect */
  padding: 40px;
  text-align: center;
  text-justify: inter-word;
  display: flex;
  flex-direction: column;
  justify-content: space-between; /* Pushes button to bottom */
  transition: transform 0.3s ease, box-shadow 0.3s ease;
  min-height: 380px; /* Ensure cards have a consistent height */
}

.content-card-2:hover {
  transform: translateY(-10px); /* Lift card on hover */
  box-shadow: 0 25px 40px rgba(0, 0, 0, 0.15); /* More pronounced shadow on hover */
}

.card-title {

  font-size: 2.2rem;
  color: #34495e;
  margin-bottom: 25px;
  font-weight: 600;
}

.card-description {

  font-size: 1.05rem;
  color: #666;
  line-height: 1.7;
  margin-bottom: 20px;
  flex-grow: 1; /* Allows text to take up available space */
  text-align: justify;
  text-justify: inter-word;
}

.card-description strong {
  color: #333;
}

.email-link {
  color: #bbd55a; /* Your accent color for email */
  text-decoration: none;
  font-weight: 600;
  transition: color 0.3s ease;
}

.email-link:hover {
  color: #bbd55a;
  text-decoration: underline;
}

.card-button {
  display: inline-block;
  background-color: #bbd55a; /* Your accent color for buttons */
  color: #0d1a26;
  padding: 12px 25px;
  border-radius: 5px;
  text-decoration: none;
 
  font-size: 1rem;
  font-weight: 600;
  letter-spacing: 0.05em;
  text-transform: uppercase;
  transition: background-color 0.3s ease, transform 0.2s ease;
  margin-top: 20px; /* Space above button */
}

.card-button:hover {
  background-color: #bbd55a; /* Darker accent on hover */
  transform: translateY(-2px); /* Slight lift on hover */
}

/* --- Responsive Adjustments --- */

/* Tablets (max-width: 1024px) */
@media (max-width: 1024px) {
  .careers-hero-section {
    padding: 100px 20px;
    height: 150px;
    margin-bottom: 40px;
  }

  .hero-title {
    font-size: 3.5rem;
  }

  .hero-subtitle {
    font-size: 1.4rem;
  }

  .main-content-cards-container {
    grid-template-columns: 1fr; /* Stack cards vertically on tablets */
    gap: 30px;
    margin-top: -60px; /* Adjust pull-up margin */
  }

  .content-card-2 {
    min-height: unset; /* Allow cards to adjust height based on content */
    padding: 30px;
  }

  .card-title {
    font-size: 2rem;
  }

  .card-description {
    font-size: 0.95rem;
  }
}

/* Mobile Devices (max-width: 767px) */
@media (max-width: 767px) {
  .careers-hero-section {
    padding: 30px 15px;
    height: 140px;
    margin-bottom: 20px;
  }

  .hero-title {
    font-size: 2.5rem;
  }

  .hero-subtitle {
    font-size: 1.1rem;
  }

  .main-content-cards-container {
    padding: 0 15px;
    margin-top: -40px; /* Further adjust pull-up margin */
  }

  .content-card-2 {
    padding: 25px;
  }

  .card-title {
    font-size: 1.8rem;
    margin-bottom: 20px;
  }

  .card-description {
    font-size: 0.9rem;
    line-height: 1.6;
    margin-bottom: 15px;
  }

  .card-button {
    padding: 10px 20px;
    font-size: 0.9rem;
  }
}

/* Very Small Mobile (max-width: 480px) */
@media (max-width: 480px) {
  .careers-hero-section {
    padding: 60px 10px;
    height: 120px;
  }

  .hero-title {
    font-size: 2rem;
  }

  .hero-subtitle {
    font-size: 0.95rem;
  }

  .content-card-2 {
    padding: 20px;
  }

  .card-title {
    font-size: 1.5rem;
  }
}
</style>